import { BellIcon } from '@heroicons/react/24/solid';
import type { PropsWithChildren } from 'react';

import Dropdown from '~/components/Dropdown';

type Props = PropsWithChildren<{
  notificationsCount: number;
  background?: string;
  color?: string;
}>;

const NotificationsDropdown = ({ children, notificationsCount, background, color }: Props) => {
  const hasNotifications = notificationsCount > 0;
  const greaterThan9 = notificationsCount > 9;

  return (
    <Dropdown
      direction="right"
      className="z-50 w-[250px] sm:w-[300px]"
      style={{
        background: background || '#fff',
      }}
      buttonChild={
        <div
          className="mt-1.5 rounded hover:bg-black/5"
          style={{
            color: color,
          }}
        >
          {hasNotifications ? (
            <div className="relative">
              <div className="absolute -right-1 -top-1 rounded-full bg-red-500 px-1 text-xs text-white">
                {greaterThan9 ? '9+' : notificationsCount}
              </div>
              <BellIcon className="h-6 w-6" />
            </div>
          ) : (
            <BellIcon className="h-6 w-6" />
          )}
        </div>
      }
    >
      <div className="h-80 overflow-auto">{children}</div>
    </Dropdown>
  );
};

export default NotificationsDropdown;
